export function resolveComposerMultiChoiceSelection(
  isLockedHistory: boolean,
  multiChoiceInitialSelection: Array<string> | undefined,
  externalSelection: Array<string> | undefined,
): Array<string> | undefined {
  const hasFrozenHistoricalSelection = (multiChoiceInitialSelection?.length ?? 0) > 0

  if (isLockedHistory && hasFrozenHistoricalSelection) {
    return multiChoiceInitialSelection
  }

  return externalSelection
}

export function canExpandHistoricalMultiChoice(
  isLockedHistory: boolean,
  multiChoiceInitialSelection: Array<string> | undefined,
): boolean {
  return isLockedHistory && (multiChoiceInitialSelection?.length ?? 0) === 0
}
